import React from 'react';

import { ReactComponent as PartnerEU } from '../../images/partner-eu.svg';
import { ReactComponent as PartnerIMF } from '../../images/partner-imf.svg';
import { ReactComponent as PartnerWB } from '../../images/partner-wb.svg';
import { ReactComponent as PartnerFR } from '../../images/partner-fr.svg';
import { ReactComponent as PartnerNO } from '../../images/partner-no.svg';
import { ReactComponent as PartnerCH } from '../../images/partner-ch.svg';
import { ReactComponent as PartnerUK } from '../../images/partner-uk.svg';
import { ReactComponent as PartnerSK } from '../../images/partner-sk.svg';
import { ReactComponent as PartnerLU } from '../../images/partner-lu.svg';

const LogoSvg = (Icon) => <Icon width={'100%'} height={'100%'} preserveAspectRatio={'xMidYMid meet'} />;

export const PARTNERS = {
  EU: LogoSvg(PartnerEU),
  IMF: LogoSvg(PartnerIMF),
  WORLD_BANK: LogoSvg(PartnerWB),
  FR: LogoSvg(PartnerFR),
  NO: LogoSvg(PartnerNO),
  CH: LogoSvg(PartnerCH),
  UK: LogoSvg(PartnerUK),
  SK: LogoSvg(PartnerSK),
  LU: LogoSvg(PartnerLU),
};
